import Vue from 'vue'
import Instance from '../main'
import VueSocketIO from 'vue-socket.io'
import io from 'socket.io-client'
import store from '../store'
import {ins as axios} from './axios'
import Version from '@/version'
export const socketModule = {
  state: {
    maxMsgCnt: 10,
    isConnected: false,
    socketMessage: '',
    connectMembers: [],
    currentMessages: [],
    surveyLogTF: false,
    lastSurveyLogs: []
  },
  getters: {
    connectMembers: state => {
      return state.connectMembers
    },
    currentMessages: state => {
      return state.currentMessages
    },
    socket: state => {
      return state.socket
    },
    isConnected: state => {
      return state.isConnected
    },
    maxMsgCnt: state => {
      return state.maxMsgCnt
    },
    surveyLogTF: state => {
      return state.surveyLogTF
    },
    lastSurveyLogs: state => {
      return state.lastSurveyLogs
    }
  },
  mutations: {
    isConnected (state, payload) {
      state.isConnected = payload
    },
    connect (state, payload) {
      state.isConnected = payload
    },
    socket_disconnect (state) {
      state.isConnected = false
    },
    getList (state, payload) {
      state.connectMembers = payload
    },
    reset (state, payload) {
      state.isConnected = false
      state.socketMessage = ''
      state.connectMembers = []
    },
    profileUpdate (state, payload) {
      const index = state.connectMembers.findIndex(m => m.objectID === payload.objectID)
      if (index !== -1) state.connectMembers.splice(index, 1, payload)
    },
    currentMessagesInit (state, payload) {
      state.currentMessages = []
    },
    currentMessages (state, payload) {
      const {from, to, message, url, type, roomID, date} = payload
      // if (state.currentMessages.length > state.maxMsgCnt) state.currentMessages.shift()
      state.currentMessages.push({from, to, message, url, type, roomID, date})
    },
    currentMessage (state, payload) {
      const {from, to, message, url, type, roomID, date} = payload
      const index = state.currentMessages.findIndex(c => c.roomID === roomID)
      if (index !== -1) state.currentMessages.splice(index, 1)
      state.currentMessages.unshift({from, to, message, url, type, roomID, date})
    },
    surveyLogTF (state, payload) {
      state.surveyLogTF = payload
    },
    surveyLogPush (state, payload) {
      if (!state.surveyLogTF) return
      if (state.lastSurveyLogs.length >= 5) state.lastSurveyLogs.pop()
      const {from, startData, endData, flag} = payload
      const {userName, userImage} = from
      const date = new Date().toLocaleString()
      if (startData) {
        const {vcID, title, surveyID} = startData
        state.lastSurveyLogs.unshift({flag, userName, userImage, vcID, title, surveyID, date})
        return
      }
      if (endData) {
        const {vcID, title, surveyID, status} = endData
        state.lastSurveyLogs.unshift({flag, userName, userImage, vcID, title, surveyID, status, date})
      }
    }
  },
  actions: {
    async getRooms (context, payload) {
      // rooms
      context.commit('currentMessagesInit', {})
      try {
        const {data} = await axios({
          url: `/users/rooms`,
          method: 'get',
          headers: {
            'Authorization': `Bearer ${this.getters.accessToken}`,
            'Panel-Hub-Version': Version
          }
        })
        const {rooms} = data
        for (let d of rooms.reverse()) {
          const convert = {
            from: d.from,
            message: d.lastMessage.message,
            url: d.lastMessage.url,
            type: d.lastMessage.type,
            roomID: d.roomID,
            date: d.updatedAt
          }
          context.commit('currentMessage', convert)
        }
      } catch (e) {
        console.log(e)
      }
    },
    disconnect (context) {
      return new Promise(async (resolve, reject) => {
        if (!Instance) return resolve()
        if (!Instance.$socket) return resolve()
        context.commit('reset')
        if (Instance.$socket) Instance.$socket.disconnect()
        console.warn('disconnect')
        return resolve()
      })
    },
    visibilityChange (context, payload) {
      return new Promise(async (resolve, reject) => {
        Instance.$socket.emit('steppedOut', {flag: payload}, (data) => {
          return resolve()
        })
      })
    },
    specificMessageInit (context, payload) {
      return new Promise(async (resolve, reject) => {
        Instance.$socket.emit('specificMessageInit', payload, ({exists, userInfo, bot, roomID}) => {
          return resolve({exists, userInfo, bot, roomID})
        })
      })
    },
    specificMessageSend (context, payload) {
      return new Promise(async (resolve, reject) => {
        Instance.$socket.emit('specificMessageSend', payload, (data) => {
          const {type, from, message} = payload
          const {exists, url, _id, roomID, date} = data
          if (data.type === 'warn') return reject(data)
          context.commit('currentMessage', {from, message, type, url, objectID: _id, roomID, date})
          return resolve({exists, url, message, _id, roomID, date})
        })
      })
    },
    socketConn (context) {
      return new Promise(async (resolve, reject) => {
        if (!context.getters.notificationPermission) return resolve(false)
        const connection = process.env.SOCKET_URL ? `wss://${process.env.SOCKET_URL}/p-platform?token=${store.getters.accessToken}` : (process.env.NODE_ENV === 'development' ? `ws://localhost:3010/p-platform?token=${store.getters.accessToken}` : `wss://v1.panel-hub.io/p-platform?token=${store.getters.accessToken}`)
        if (Instance) {
          if (Instance.$socket) Instance.$socket.disconnect()
        }
        context.commit('reset')
        const socketIO = io(connection, {
          transports: ['websocket']
        })
        const socketInstance = new VueSocketIO({
          debug: false,
          connection: socketIO,
          vuex: {
            store,
            actionPrefix: 'socket_',
            mutationPrefix: 'socket_'
          }
        })
        Vue.use(socketInstance)
        return resolve(true)
      })
    },
    changeProfile (context, payload) {
      return new Promise(async (resolve, reject) => {
        Instance.$socket.emit('changeProfile', payload, (data) => {
        })
        return resolve(true)
      })
    },
    getList (context, payload) {
      return new Promise(async (resolve, reject) => {
        return resolve(true)
      })
    },
    surveyLogToggle (context, payload) {
      context.commit('surveyLogTF', payload)
    },
    surveyLogPush (context, payload) {
      context.commit('surveyLogPush', payload)
    },
    'socket_welcome' (context, payload) {
      return new Promise(async (resolve, reject) => {
        context.commit('isConnected', true)
        if (context.getters.isConnected) await context.dispatch('getRooms')
        Instance.$socket.emit('getList', {}, (data) => {
          context.commit('getList', data)
        })
        return resolve(true)
      })
    },
    'socket_connect' (context, payload) {
      console.debug('socket conn', payload)
    },
    'socket_getList' (context, payload) {
    },
    'socket_noticeChangeProfile' (context, payload) {
      context.commit('profileUpdate', payload)
    },
    'socket_conn_notice' (context, payload) {
      return new Promise(async (resolve, reject) => {
        Instance.$socket.emit('getList', {}, (data) => {
          context.commit('getList', data)
        })
        return resolve(context)
      })
    },
    'socket_noticeSteppedOut' (context, payload) {
      context.commit('profileUpdate', payload)
    },
    'socket_specificMessageRcv' (context, payload) {
      // const {from, to, message, type, url, _id, roomID, date} = payload
      // context.commit('currentMessage', {from, to, message, type, url, _id, roomID, date})
    },
    'socket_specificMessageRcvForNav' (context, payload) {
      const {from, to, message, type, url, _id, roomID, date} = payload
      context.commit('currentMessage', {from, to, message, type, url, _id, roomID, date})
    },
    'socket_specificMessageSendForSurveyStart' (context, payload) {
      context.commit('surveyLogPush', {...payload, flag: 'start'})
    },
    'socket_specificMessageSendForSurveyEnd' (context, payload) {
      context.commit('surveyLogPush', {...payload, flag: 'end'})
    },
    'socket_specificMessageQueueStart' (context, payload) {
    },
    'socket_specificMessageQueueEnd' (context, payload) {
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugin/socket.io.js